<template>
  <div>
    <v-card>
      <v-toolbar
        light
        color="white"
        class="elevation-2"
      >
        <v-toolbar-title>
          <router-link
            class="no-decoration grey--text text--darken-1"
            to="/uzytkownicy/1"
          >Użytkownicy</router-link>
          <v-icon color="grey" class="mx-2">chevron_right</v-icon>
          {{name}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <v-btn
            slot="activator"
            icon
            @click="editUser"
          >
            <v-icon
              color="primary"
            >edit</v-icon>
          </v-btn>
          <span>Edytuj użytkownika</span>
        </v-tooltip>
      </v-toolbar>
      <v-layout class="py-2" wrap :class="paddingClass">
        <v-flex xs12 md6>

          <v-layout py-2 wrap>
            <v-flex xs12 pb-2 pt-2>
              <span class="title grey--text ">Dane użytkownika: </span>
            </v-flex>
          </v-layout>

          <v-layout py-2 wrap>
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Nazwa: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2">{{name}}</span>
            </v-flex>
          </v-layout>

          <v-layout py-2 wrap v-if="hasEmail">
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Adres e-mail: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2" v-html="hasEmail"></span>
            </v-flex>
          </v-layout>

          <v-layout py-2 wrap v-if="singleUser.status_txt">
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Status: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2">{{singleUser.status_txt}}</span>
            </v-flex>
          </v-layout>


          <v-layout py-2 wrap v-if="singleUser.role_txt">
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Rodzaj konta: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2">{{singleUser.role_txt}}</span>
            </v-flex>
          </v-layout>

          <v-layout py-2 wrap v-if="singleUser.created_at">
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Data utworzenia: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2">{{singleUser.created_at}}</span>
            </v-flex>
          </v-layout>

        </v-flex>
        <v-flex xs12 md6>

          <v-layout py-2 wrap>
            <v-flex xs12 pb-2 pt-2>
              <span class="title grey--text ">Dane logowania: </span>
            </v-flex>
          </v-layout>

          <v-layout py-2 wrap v-if="singleUser.pin">
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Kod PIN: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2">
                {{singleUser.pin}}
              </span>
            </v-flex>
          </v-layout>

          <v-layout py-2 wrap v-if="singleUser.email">
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Login: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2">
                {{singleUser.email}}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card v-if="showGdSection" class="mt-4">
      <v-toolbar
        light
        color="white"
        class="elevation-2"
      >
        <v-toolbar-title>
          Google Drive
        </v-toolbar-title>
      </v-toolbar>
      <v-layout>
        <v-flex xs8 py-2 :class="paddingClass">
          <v-layout py-2 v-if="singleUser.gd_client_id" wrap>
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Client ID: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2 white-space-wrap">{{singleUser.gd_client_id}}</span>
            </v-flex>
          </v-layout>

          <v-layout py-2 v-if="singleUser.gd_client_secret" wrap>
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Client Secret: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2 white-space-wrap">{{singleUser.gd_client_secret}}</span>
            </v-flex>
          </v-layout>

          <v-layout py-2 v-if="singleUser.gd_refresh_token" wrap>
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Refresh Token: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2 white-space-wrap">{{singleUser.gd_refresh_token}}</span>
            </v-flex>
          </v-layout>

          <v-layout py-2 v-if="singleUser.gd_folder_id" wrap>
            <v-flex xs12 sm3>
              <span class="grey--text text--darken-2 body-1">Folder ID: </span>
            </v-flex>
            <v-flex xs12 sm9>
              <span class="body-2 white-space-wrap">{{singleUser.gd_folder_id}}</span>
            </v-flex>
          </v-layout>

        </v-flex>

      </v-layout>
    </v-card>
    <UserEditDialog />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserEditDialog from './../Users/Dialogs/UserEditDialog.vue';

export default {
  name: 'user-info',
  props: ['singleUser'],
  components: { UserEditDialog },
  computed: {
    name() {
      return `${this.singleUser.first_name} ${this.singleUser.last_name}`;
    },
    userId() {
      return this.$route.params.id;
    },
    hasEmail() {
      const mail = this.singleUser.email;
      const mailHtml = `<a href="mailto:${mail}">${mail}</a>`;
      return mail ? mailHtml : false;
    },
    showGdSection() {
      return this.singleUser.gd_client_id
        || this.singleUser.gd_client_secret
        || this.singleUser.gd_refresh_token
        || this.singleUser.gd_folder_id;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-3' : 'px-4';
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    editUser() {
      this.setDialogVisbility({ type: 'edit', id: this.userId });
    },
  },
};
</script>
